import React from "react";

function MLMHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-9.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  MLM Developments & Services
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology specializes in developing robust Multi-Level
                    Marketing (MLM) platforms tailored to fit any business
                    model. Whether you’re building a network marketing platform
                    from the ground up or enhancing an existing one, we provide
                    end-to-end solutions that empower your business to grow,
                    scale, and manage network members efficiently.
                  </p>
                  <div className="button mt-30 fade-up-anim">
                    <a href="#" className="btn btn-style-one light">
                      Join Today
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="banner-two-right-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/thumb/1.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="top-info fade-up-anim" data-wow-delay="100ms">
                  <h4>Handle everything in quick &amp; instant</h4>
                  <h5>500+ Reviews</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MLMHero;
